import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Route from "./Route";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <GoogleOAuthProvider clientId="57257109537-27scm52tl5qjpki4nbis4emoitvh00i9.apps.googleusercontent.com">
      <Router>
        <Route />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
